<div class="login-container" [@fadeIn]>
  <!-- Mobile Header (visible only on mobile) -->
  <!-- <div class="login-header-mobile">
    <div class="login-header-mobile__content">
      <h1>{{ 'LOGIN.MOBILE_TITLE' | translate }}</h1>
      <p>{{ 'LOGIN.MOBILE_SUBTITLE' | translate }}</p>
    </div>
  </div> -->

  <!-- Main Content Container (Formulaire à gauche sur desktop) -->
  <div class="login-content">
    <div class="login-content__inner" [@slideInUp]>

      <!-- Bannière mode maintenance -->
      <div *ngIf="isMaintenanceMode" class="login-maintenance-banner" role="alert" aria-live="assertive">
        <div class="login-maintenance-banner__icon">
          <i class="pi pi-wrench"></i>
        </div>
        <div class="login-maintenance-banner__text">
          <strong>Application en maintenance</strong>
          <span>L'accès aux fonctionnalités est temporairement suspendu. Seule la connexion est disponible.</span>
        </div>
      </div>

      <!-- Logo Centré -->
      <div class="login-logo login-logo--centered" role="img" aria-label="My Cimencam Logo">
        <img src="/assets/icons/Logo CIMENCAM.svg" alt="My Cimencam" loading="eager" width="200" height="70" />
      </div>

      <!-- Header -->
      <div class="login-header">
        <h1>{{ 'LOGIN.TITLE' | translate }}</h1>
        <p>{{ 'LOGIN.SUBTITLE' | translate }}</p>
      </div>

      <!-- Tabs avec animation de slide indicator -->
      <div class="login-tabs" role="tablist">
        <button type="button" class="login-tabs__btn" [class.login-tabs__btn--active]="activeTab === 'email'"
          (click)="setActiveTab('email')" [attr.aria-selected]="activeTab === 'email'" role="tab"
          [attr.aria-controls]="'email-tabpanel'" [attr.tabindex]="activeTab === 'email' ? 0 : -1">
          {{ 'LOGIN.TAB_EMAIL' | translate }}
        </button>
        <button type="button" class="login-tabs__btn" [class.login-tabs__btn--active]="activeTab === 'phone'"
          (click)="setActiveTab('phone')" [attr.aria-selected]="activeTab === 'phone'" role="tab"
          [attr.aria-controls]="'phone-tabpanel'" [attr.tabindex]="activeTab === 'phone' ? 0 : -1">
          {{ 'LOGIN.TAB_PHONE' | translate }}
        </button>
        <!-- Active indicator animé -->
        <span class="login-tabs__indicator" [class.login-tabs__indicator--phone]="activeTab === 'phone'"
          aria-hidden="true">
        </span>
      </div>

      <!-- Email Login Form avec animation -->
      <form *ngIf="activeTab === 'email'" [@formSlide] [formGroup]="loginForm" (ngSubmit)="onSubmit()"
        class="login-form" novalidate [attr.aria-labelledby]="'email-tabpanel'" role="tabpanel" id="email-tabpanel">

        <!-- Email Input avec icône dans le label -->
        <div class="login-form__group" [@fieldFadeIn]>
          <label for="email" class="login-form__label login-form__label--with-icon">
            <i class="pi pi-envelope" aria-hidden="true"></i>
            <span>{{ 'LOGIN.EMAIL_LABEL' | translate }}</span>
            <span class="login-form__required" aria-label="requis">*</span>
          </label>
          <input pInputText id="email" type="email" formControlName="email" class="w-full"
            [class.ng-invalid]="email?.invalid && email?.touched" [class.ng-valid]="email?.valid && email?.touched"
            [class.login-form__input--error]="email?.invalid && email?.touched"
            [class.login-form__input--success]="email?.valid && email?.touched"
            placeholder="{{ 'LOGIN.EMAIL_PLACEHOLDER' | translate }}" autocomplete="email" aria-required="true"
            [attr.aria-invalid]="email?.invalid && email?.touched"
            [attr.aria-describedby]="email?.invalid && email?.touched ? 'email-error' : null" />
          <!-- Messages d'erreur avec animation -->
          <div class="login-form__error-container" [@errorSlide] *ngIf="email?.invalid && email?.touched">
            <small id="email-error" class="login-form__error" role="alert" aria-live="polite">
              <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
              <span *ngIf="email?.errors?.['required']">{{ 'LOGIN.EMAIL_REQUIRED' | translate }}</span>
              <span *ngIf="email?.errors?.['email']">{{ 'LOGIN.EMAIL_INVALID' | translate }}</span>
            </small>
          </div>
        </div>

        <!-- Password Input avec icône dans le label -->
        <div class="login-form__group" [@fieldFadeIn]>
          <label for="password" class="login-form__label login-form__label--with-icon">
            <i class="pi pi-lock" aria-hidden="true"></i>
            <span>{{ 'LOGIN.PASSWORD_LABEL' | translate }}</span>
            <span class="login-form__required" aria-label="requis">*</span>
          </label>
          <p-password id="password" formControlName="password" [toggleMask]="true" [feedback]="false"
            [class.ng-invalid]="password?.invalid && password?.touched"
            [class.ng-valid]="password?.valid && password?.touched"
            placeholder="{{ 'LOGIN.PASSWORD_PLACEHOLDER' | translate }}" autocomplete="current-password"
            styleClass="w-full" [inputStyleClass]="'w-full'" aria-required="true"
            [attr.aria-invalid]="password?.invalid && password?.touched"
            [attr.aria-describedby]="password?.invalid && password?.touched ? 'password-error' : null">
          </p-password>
          <!-- Messages d'erreur avec animation -->
          <div class="login-form__error-container" [@errorSlide] *ngIf="password?.invalid && password?.touched">
            <small id="password-error" class="login-form__error" role="alert" aria-live="polite">
              <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
              <span *ngIf="password?.errors?.['required']">{{ 'LOGIN.PASSWORD_REQUIRED' | translate }}</span>
              <span *ngIf="password?.errors?.['minlength']">{{ 'LOGIN.PASSWORD_MIN_LENGTH' | translate: { min: password?.errors?.['minlength']?.requiredLength } }}</span>
            </small>
          </div>
        </div>

        <!-- Remember Me & Language Selector -->
        <div class="login-form__actions">
          <div class="login-form__checkbox-wrapper">
            <p-checkbox formControlName="rememberMe" [binary]="true" [inputId]="'rememberMe'"
              styleClass="login-form__checkbox">
            </p-checkbox>
            <label for="rememberMe" class="login-form__checkbox-label">
              {{ 'LOGIN.REMEMBER_ME' | translate }}
            </label>
          </div>
          <app-language-switcher></app-language-switcher>
        </div>

        <!-- Bouton Connexion Sécurisée (Submit) -->
        <button type="submit" class="login-form__submit-secure" [disabled]="loginForm.invalid || isLoading"
          [class.login-form__submit-secure--loading]="isLoading">
          <i class="pi" [class.pi-spin]="isLoading" [class.pi-spinner]="isLoading" [class.pi-shield]="!isLoading"
            aria-hidden="true"></i>
          <span>{{ isLoading ? ('COMMON.LOADING' | translate) : ('LOGIN.SECURE_CONNECTION_BUTTON' | translate) }}</span>
        </button>
      </form>

      <!-- Phone Login Form avec animation -->
      <form *ngIf="activeTab === 'phone'" [@formSlide] [formGroup]="phoneForm" (ngSubmit)="onSubmit()"
        class="login-form" novalidate [attr.aria-labelledby]="'phone-tabpanel'" role="tabpanel" id="phone-tabpanel">

        <!-- Phone Input avec icône dans le label -->
        <div class="login-form__group" [@fieldFadeIn]>
          <label for="phone" class="login-form__label login-form__label--with-icon">
            <i class="pi pi-phone" aria-hidden="true"></i>
            <span>{{ 'LOGIN.PHONE_LABEL' | translate }}</span>
            <span class="login-form__required" aria-label="requis">*</span>
          </label>
          <input pInputText id="phone" type="tel" formControlName="phone" class="w-full"
            [class.ng-invalid]="phone?.invalid && phone?.touched" [class.ng-valid]="phone?.valid && phone?.touched"
            [class.login-form__input--error]="phone?.invalid && phone?.touched"
            [class.login-form__input--success]="phone?.valid && phone?.touched"
            placeholder="{{ 'LOGIN.PHONE_PLACEHOLDER' | translate }}" autocomplete="tel" aria-required="true"
            [attr.aria-invalid]="phone?.invalid && phone?.touched"
            [attr.aria-describedby]="phone?.invalid && phone?.touched ? 'phone-error' : null" />
          <!-- Messages d'erreur avec animation -->
          <div class="login-form__error-container" [@errorSlide] *ngIf="phone?.invalid && phone?.touched">
            <small id="phone-error" class="login-form__error" role="alert" aria-live="polite">
              <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
              <span *ngIf="phone?.errors?.['required']">{{ 'LOGIN.PHONE_REQUIRED' | translate }}</span>
              <span *ngIf="phone?.errors?.['invalidPhone']">{{ 'LOGIN.PHONE_INVALID' | translate }}</span>
            </small>
          </div>
          <!-- Helper text pour le format -->
          <small class="login-form__helper" *ngIf="!phone?.touched || phone?.valid">
            <i class="pi pi-info-circle" aria-hidden="true"></i>
            {{ 'LOGIN.PHONE_FORMAT' | translate }}
          </small>
        </div>

        <!-- Remember Me & Language Selector -->
        <div class="login-form__actions">
          <div class="login-form__checkbox-wrapper">
            <p-checkbox formControlName="rememberMe" [binary]="true" [inputId]="'rememberMePhone'"
              styleClass="login-form__checkbox">
            </p-checkbox>
            <label for="rememberMePhone" class="login-form__checkbox-label">
              {{ 'LOGIN.REMEMBER_ME' | translate }}
            </label>
          </div>
          <app-language-switcher></app-language-switcher>
        </div>

        <!-- Info OTP -->
        <div class="login-form__info-box" role="status">
          <i class="pi pi-info-circle" aria-hidden="true"></i>
          <span>{{ 'LOGIN.OTP_INFO' | translate }}</span>
        </div>

        <!-- Bouton Connexion Sécurisée (Submit) -->
        <button type="submit" class="login-form__submit-secure" [disabled]="phoneForm.invalid || isLoading"
          [class.login-form__submit-secure--loading]="isLoading">
          <i class="pi" [class.pi-spin]="isLoading" [class.pi-spinner]="isLoading" [class.pi-shield]="!isLoading"
            aria-hidden="true"></i>
          <span>{{ isLoading ? ('COMMON.LOADING' | translate) : ('LOGIN.SECURE_CONNECTION_BUTTON' | translate) }}</span>
        </button>
      </form>

      <!-- Footer -->

    </div>
  </div>

  <!-- Desktop Visual (visible only on desktop/tablette, à droite) -->
  <div class="login-visual" role="complementary" aria-label="Welcome visual" [@fadeIn]>
    <div class="login-visual__content">
      <!-- Animation background -->
      <div class="login-visual__animation" aria-hidden="true">
        <div class="login-visual__circle login-visual__circle--red"></div>
        <div class="login-visual__circle login-visual__circle--green"></div>
        <!-- Gradient overlay -->
        <div class="login-visual__gradient"></div>
      </div>

      <!-- Content -->
      <div class="login-visual__text">
        <h2 class="login-visual__title">{{ 'LOGIN.SFA_TITLE' | translate }}</h2>
        <p class="login-visual__subtitle">{{ 'LOGIN.SFA_SUBTITLE' | translate }}</p>

        <!-- Features list for SFA -->
        <ul class="login-visual__features" role="list">
          <li class="login-visual__feature">
            <i class="pi pi-chart-line" aria-hidden="true"></i>
            <span>{{ 'LOGIN.SFA_FEATURE_1' | translate }}</span>
          </li>
          <li class="login-visual__feature">
            <i class="pi pi-users" aria-hidden="true"></i>
            <span>{{ 'LOGIN.SFA_FEATURE_2' | translate }}</span>
          </li>
          <li class="login-visual__feature">
            <i class="pi pi-mobile" aria-hidden="true"></i>
            <span>{{ 'LOGIN.SFA_FEATURE_3' | translate }}</span>
          </li>
          <li class="login-visual__feature">
            <i class="pi pi-map-marker" aria-hidden="true"></i>
            <span>{{ 'LOGIN.SFA_FEATURE_4' | translate }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- Toast Messages avec configuration améliorée -->
  <p-toast position="top-right" [life]="5000" [showTransformOptions]="'translateX(100%)'"
    [hideTransformOptions]="'translateX(100%)'" [showTransitionOptions]="'300ms cubic-bezier(0.4, 0, 0.2, 1)'"
    [hideTransitionOptions]="'300ms cubic-bezier(0.4, 0, 0.2, 1)'">
  </p-toast>

  <!-- Offline indicator -->
  <div class="login-offline-indicator" *ngIf="!isOnline" [@slideDown] role="alert">
    <i class="pi pi-wifi" aria-hidden="true"></i>
    <span>{{ 'COMMON.OFFLINE_MODE' | translate }}</span>
  </div>
</div>